/**
 * Charge table column configuration for Analytics
 * Defines which columns support filtering and sorting
 */

/**
 * Columns that support filtering with metadata
 */
export const CHARGE_FILTER_COLUMNS = new Set([
  'chargeDomain',
  'chargeName',
  'legType',
  'chargeStatus',
  'chargeStatusReason',
  'serviceProvider',
  'serviceType',
  'modality',
  'billedEntity',
  'quantityUnit',
  'shipmentNumber',
  'invoiceNumber',
  'pol',
  'pod',
]);

/**
 * Columns that support sorting only (no filter metadata)
 */
export const CHARGE_SORT_ONLY_COLUMNS = new Set([
  'deviationAmountInInvoiceCurrency',
  'chargeAmount',
  'chargeAmountInInvoiceCurrency',
  'chargeAmountInReferenceCurrency',
  'chargeQuantity',
  'chargeUnitPrice',
  'exchangeRate',
  'date',
]);

/**
 * All sortable columns (filter + sort-only)
 */
export const CHARGE_SORTABLE_COLUMNS = new Set([...CHARGE_FILTER_COLUMNS, ...CHARGE_SORT_ONLY_COLUMNS]);

/**
 * Maps UI column accessorKeys to API column names
 */
export const CHARGE_COLUMN_NAME_MAP: Record<string, string> = {
  chargeDomain: 'CHARGE_DOMAIN',
  chargeName: 'CHARGE_NAME',
  legType: 'LEG_TYPE',
  chargeStatus: 'CHARGE_STATUS',
  chargeStatusReason: 'CHARGE_STATUS_REASON',
  serviceProvider: 'SERVICE_PROVIDER_NAME',
  serviceType: 'SERVICE',
  modality: 'MODALITY',
  billedEntity: 'BILLED_ENTITY',
  quantityUnit: 'QUANTITY_UNIT',
  shipmentNumber: 'SHIPMENT_NUMBER',
  invoiceNumber: 'INVOICE_NUMBER',
  pol: 'POL',
  pod: 'POD',
};
